import { Router } from "@angular/router";

const PENDING_NEW_TAB_NAV_STATE_KEY = "condor_pending_new_tab_nav_state";
const PERSONA_NEW_TAB_IDCDR_KEY = "condor_newtab_idcdr";

export function shouldOpenInNewTab(event?: MouseEvent): boolean {
  return !!event && (event.button === 1 || event.ctrlKey || event.metaKey);
}

export function savePendingNewTabNavigationState(
  state?: Record<string, unknown> | null,
): void {
  if (!state) {
    sessionStorage.removeItem(PENDING_NEW_TAB_NAV_STATE_KEY);
    return;
  }

  sessionStorage.setItem(
    PENDING_NEW_TAB_NAV_STATE_KEY,
    JSON.stringify(state),
  );
}

export function consumePendingNewTabNavigationState<
  T extends Record<string, unknown>,
>(): T | null {
  const rawState = sessionStorage.getItem(PENDING_NEW_TAB_NAV_STATE_KEY);

  if (!rawState) {
    return null;
  }

  sessionStorage.removeItem(PENDING_NEW_TAB_NAV_STATE_KEY);

  try {
    return JSON.parse(rawState) as T;
  } catch {
    return null;
  }
}

export function openRouteInNewTab(
  router: Router,
  route: string,
  state?: Record<string, unknown> | null,
): void {
  savePendingNewTabNavigationState(state);

  if (route === "per_personas/datos-personales") {
    const idcdr = state?.["idcdr"];

    if (idcdr != null && idcdr !== "") {
      sessionStorage.setItem(PERSONA_NEW_TAB_IDCDR_KEY, String(idcdr));
    } else {
      sessionStorage.removeItem(PERSONA_NEW_TAB_IDCDR_KEY);
    }
  }

  const serializedUrl = router.serializeUrl(router.createUrlTree([route]));
  const newWindow = window.open(serializedUrl, "_blank");

  // Avoid leaking navigation bridge state into subsequent navigations
  // in the current tab (multi-tab scenario).
  sessionStorage.removeItem(PENDING_NEW_TAB_NAV_STATE_KEY);
  sessionStorage.removeItem(PERSONA_NEW_TAB_IDCDR_KEY);

  if (newWindow) {
    newWindow.blur();
  }

  window.focus();
}